<script>
	import { onMount, setContext } from 'svelte'
	// import { Router, Link, Route, navigate } from 'svelte-routing'
	import { Router, Route, Link, navigateTo } from 'yrv'
	import axios from 'axios'
	import wait from './libs/wait'
	import { BROWSER } from './libs/utils'

	import Login from './routes/Login/Login.svelte'
	import Sectors from './routes/Sectors/Sectors.svelte'
	import Dashboard from './routes/Dashboard/Dashboard.svelte'
	import Clients from './routes/Clients/Clients.svelte'
	import ClientAlerts from './routes/Clients/ClientAlerts.svelte'
	// import ClientRoute from './routes/Clients/ClientRoute.svelte'
	import ClientDashboard from './routes/Clients/ClientDashboard.svelte'
	import ClientDetails from './routes/Clients/ClientDetails.svelte'
	import QueryDashboard from './routes/Query/QueryDashboard.svelte'
	import ProgramsList from './routes/Programs/ProgramsList.svelte'
	import VacationsDashboard from './routes/Vacations/VacationsDashboard.svelte'
	import AlertsDashboard from './routes/Alerts/AlertsDashboard.svelte'
	import UsersList from './routes/Users/UsersList.svelte'
	import Error from './components/Modal/Error.svelte'
	import Sidebar from './components/Sidebar/Sidebar.svelte'
	import Maintenance from './routes/Global/Maintenance/Maintenence.svelte'
	import AppNotifications from './components/Notifications/AppNotifications.svelte'
	import GlobalStylesFixes from './routes/Global/Styles/GlobalStylesFixes.svelte'
	import ViewportChangeListener from './components/Utils/ViewportChangeListener.svelte'
	// import Search from './routes/Global/Search/Search.svelte'

	import userStore from './stores/user'
	import { width, height, vHeight } from './stores/bounds'
	import { background as backgroundStore, confirm as confirmStore } from './stores/app'
	import storage from './libs/storage'

	let background = false,
		confirm = false,
		appbusy = false,
		maintenance = false,
		error = false,
		errorObj = null,
		search = false,
		searchQuery = '',
		userThread = null

	setContext('mobileDevice', BROWSER.isMobile())
	setContext('iPadDevice', BROWSER.isIpadOS())

	userStore.init()

	axios.interceptors.response.use(
		(response) => response,
		(e, n) => {
			if (e.response !== undefined) {
				const { status } = e.response
				// console.log ('interceptor', status, typeof (e.response.data))

				document.body.style.backgroundColor = ''
				if (status === 401) {
					if (window.location.pathname !== '/login') navigateTo('/login')
				} else if (status === 503) {
					maintenance = true
					appbusy = true
				} else if (typeof e.response.data !== 'string' && e.response.data.loginError) {
					// login specific error ...
				} else {
					error = true
					errorObj = typeof e.response.data !== 'string' ? e.response.data : ''
				}
			}
			return Promise.reject(e)
		}
	)

	const retrieveUserInfo = () => {
		if (window.location.pathname === '/login') return

		axios
			.post('/api/jwtlogin/user')
			.then((result) => {
				// console.log (JSON.stringify (result.data, null, '  '))
				if (result?.data?.error === 'user_disabled') {
					navigateTo('/login')
					return
				}

				userStore.setUser(result.data)
			})
			.catch((e) => {})
	}

	const retrieveSectorInfo = () => {
		const sector_storage = storage.get('sector')
		if (sector_storage) userStore.setSector(sector_storage)
	}

	const onDisposeError = () => {
		error = null
		errorObj = null
		// history.back ();
	}

	const bootstrapApp = () => {
		retrieveUserInfo()
		retrieveSectorInfo()
		setBounds()
		window.addEventListener('resize', setBounds)

		if (userThread) clearInterval(userThread)
		userThread = setInterval(() => retrieveUserInfo(), 60000)
		// wait (3000).then (() => {
		// 	maintenance = true;
		// 	appbusy = true
		// })
	}

	const setBounds = () => {
		height.set(window.innerHeight)
		width.set(window.innerWidth)
		vHeight.set(window.innerWidth > 640 ? window.innerHeight : window.innerHeight - 50)
	}

	const onAppEvent = (event) => {
		const { type, detail } = event
		const { id, value } = detail
		// console.log ('onAppEvent', type, detail)

		if (id === 'background') {
			background = value
			backgroundStore.set(value)
		} else if (id === 'confirm') {
			confirm = true
			confirmStore.set(true)
			wait(800).then(() => {
				confirm = false
				confirmStore.set(false)
			})
		} else if (id === 'appbusy') {
			appbusy = value
		} else if (id === 'login') retrieveUserInfo()
	}

	const onSidebarAction = (event) => {
		const detail = event.detail
		const { id, value } = detail
		if (id === 'search') search = value
		else if (id === 'logout') onLogout()
	}

	const onLogout = () => {
		background = true
		axios
			.get('/api/jwtlogin/logout')
			.then((result) => {
				setTimeout(() => {
					background = false
					navigateTo('/login')
				}, 100)
			})
			.catch((e) => {
				background = false
			})
	}

	onMount(bootstrapApp)

	$: colorClss = $userStore && $userStore.sector ? 'brand-' + $userStore.sector.color : ''
</script>

<div class="App {colorClss}" style="--windowWidth:{$width}px;--windowHeight:{$height}px;">
	<Router>
		<Route path="/login">
			<Login on:app-event={onAppEvent} />
		</Route>
		<Route path="/app">
			<Sidebar background={$backgroundStore} {search} {appbusy} on:action={onSidebarAction} />
			<GlobalStylesFixes />
			<Router>
				<Route path="/" exact>
					<Sectors on:app-event={onAppEvent} />
				</Route>
				<Route path="/clients">
					<Clients on:app-event={onAppEvent} />
				</Route>
				<Route path="/clients/:id/details" let:router>
					<ClientDetails id={router.params.id} on:app-event={onAppEvent} />
				</Route>
				<Route path="/clients/:id/logs" let:router>
					<ClientDashboard id={router.params.id} on:app-event={onAppEvent} />
				</Route>
				<Route path="/clients/:id/alerts" let:router>
					<ClientAlerts id={router.params.id} on:app-event={onAppEvent} />
				</Route>
				<Route path="/programs/:id" let:router>
					<ProgramsList id={router.params.id} {router} on:app-event={onAppEvent} />
				</Route>
				<Route path="/dashboard/:id" let:router>
					<Dashboard id={router.params.id} on:app-event={onAppEvent} />
				</Route>
				<Route path="/vacations/:id" let:router>
					<VacationsDashboard id={router.params.id} on:app-event={onAppEvent} />
				</Route>
				<Route path="/query/:id" let:router>
					<QueryDashboard id={router.params.id} on:app-event={onAppEvent} />
				</Route>
				<Route path="/alerts/:id" let:router>
					<AlertsDashboard id={router.params.id} on:app-event={onAppEvent} />
				</Route>
				<Route path="/operators/:id" let:router>
					<UsersList id={router.params.id} admin={router.query.admin} on:app-event={onAppEvent} />
				</Route>
			</Router>
		</Route>
	</Router>
</div>

{#if error}
	<Error {...errorObj} on:errordispose={onDisposeError} />
{/if}

{#if maintenance}
	<Maintenance />
{/if}

<AppNotifications />
<ViewportChangeListener />

<style global lang="postcss">
	@tailwind base;
	@tailwind components;
	@tailwind utilities;
</style>
